@if (formRef()) {
  <div [formGroup]="formRef()">
    <div class="mt-6">
      <label class="comcast-input-label" for="reporter-trigger"
        >Primary reporter</label
      >

      @if (isLoadingReporters()) {
        <div
          class="mt-2 animate-pulse"
          role="status"
          aria-label="Loading reporters"
        >
          <div class="h-12 w-full rounded-sm bg-gray-200"></div>
        </div>
      } @else {
        <div class="relative mt-2">
          <button
            id="reporter-trigger"
            type="button"
            class="comcast-select-trigger"
            [class.comcast-select-trigger--open]="isDropdownOpen()"
            [class.comcast-select-trigger--filled]="!!selectedReporterLabel()"
            [class.comcast-input-invalid]="inlineErrors().reporter"
            [attr.aria-expanded]="isDropdownOpen()"
            aria-haspopup="listbox"
            aria-controls="reporter-listbox"
            aria-required="true"
            [attr.aria-invalid]="!!inlineErrors().reporter"
            [attr.aria-describedby]="
              inlineErrors().reporter ? 'reporter-error' : null
            "
            (click)="toggleDropdown($event)"
          >
            <span [class.text-brand-muted]="!selectedReporterLabel()">
              {{ selectedReporterLabel() || 'Please select' }}
            </span>
            <mat-icon
              class="text-brand-text flex! h-5! w-5! items-center! justify-center! text-xl!"
              aria-hidden="true"
            >
              {{ isDropdownOpen() ? 'arrow_drop_up' : 'arrow_drop_down' }}
            </mat-icon>
          </button>

          @if (isDropdownOpen()) {
            <div
              id="reporter-listbox"
              class="comcast-select-panel"
              role="listbox"
              aria-label="Primary reporter"
              [class.comcast-select-panel--open]="isDropdownOpen()"
              [class.comcast-select-panel--invalid]="inlineErrors().reporter"
              (click)="$event.stopPropagation()"
            >
              <div class="comcast-select-search">
                <mat-icon
                  class="text-brand-muted flex! h-5! w-5! items-center! justify-center! text-xl!"
                  aria-hidden="true"
                >
                  search
                </mat-icon>
                <input
                  type="text"
                  placeholder="Search"
                  aria-label="Search reporters"
                  [value]="reporterSearchTerm()"
                  (input)="onSearchInput($event)"
                  class="comcast-select-search-input"
                  appAutofocus
                />
              </div>
              <div class="comcast-select-options">
                @for (rep of filteredReporters(); track rep.Id) {
                  <div
                    class="comcast-select-option"
                    role="option"
                    tabindex="0"
                    [attr.aria-selected]="formRef().value.reporter === rep.Id"
                    [class.comcast-select-option--selected]="
                      formRef().value.reporter === rep.Id
                    "
                    (click)="selectReporter(rep, $event)"
                    (keydown.enter)="selectReporter(rep, $event)"
                    (keydown.space)="selectReporter(rep, $event)"
                  >
                    {{ rep.Name | titlecase }}
                  </div>
                }
                @if (!filteredReporters().length) {
                  <div
                    class="text-brand-muted font-lato px-4 py-3 text-sm"
                    role="option"
                    aria-disabled="true"
                  >
                    No results found
                  </div>
                }
              </div>
            </div>
          }
        </div>

        @if (inlineErrors().reporter) {
          <div
            id="reporter-error"
            class="comcast-validation-error"
            role="alert"
          >
            {{ inlineErrors().reporter }}
          </div>
        }

        @if (primaryReporter()) {
          <app-radio-select
            [formRef]="formRef()"
            [reporter]="primaryReporter()"
            [altContact]="altContact()"
            [inlineErrors]="inlineErrors()"
            (changeContact)="canSubmit()"
          ></app-radio-select>
        }
      }
    </div>
  </div>
}
